export const registration: object = {
  registration: {
    heading: 'Create a Company Account',
    headingB2I: 'Personal Details',
    headingAddress: 'Address',
    headingName: 'Name',
    subheading: 'Please provide the following information about your company or\n organization.',
    subheadingB2I: 'Please provide the following information about you.',
    headingSelectCompany: 'Select a Company / Organization',
    subheadingSelectCompany: 'The selected company will be the business entity associated to your SAP Store account.',
    backButton: 'Back',
    searchPlaceholder: 'Search',
    backToSolutionPage: 'Back to Solution Page',
    newCompany: {
      createNew1: 'This information is defined by your company domain administrators.',
      createNew2: 'Don\'t see your company? Please check with the super administrator or ',
      createNew3: 'create new.'
    },
    newCompanyAddress: {
      heading: 'Create a Company Address',
      subheading: 'Please provide the following information about your company or\n organization. We use this information for billing purposes.'
    },
    customerName: {
      heading: 'Account Details',
      subheading: 'Please provide the following information.',
      addingCompanyDisclaimer: 'Adding an organization helps us determine whether your organization has any pre-existing contracts which may affect this purchase.'
    },
    addressSelection: {
      heading: 'Select an Address',
      subheading: 'Please confirm the address for <strong>{{companyName}}</strong>. It will be used to identify the' +
        ' corresponding legal entity for your SAP Store account.',
      createNew1: 'This information is defined by your company domain administrators.',
      createNew2: 'Don\'t see your company? Please check with the super administrator or ',
      createNew3: 'create new.'
    },
    placeholder: {
      countryCode: 'Country',
      company: 'Company/Organization Name',
      street: 'Address',
      addressLine2: 'Address Line 2 (Optional)',
      city: 'City',
      regionCode: 'State',
      postalCode: 'Postal Code',
      lineOfBusiness: 'Industry',
    },
    company: {
      loading: 'Please wait. We are preparing your account information.',
    },
    label: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email *',
      countryCode: 'Country *',
      company: 'Company/Organization Name *',
      department: 'Department *',
      street: 'Address *',
      addressLine2: 'Address Line 2 (Optional)',
      city: 'City *',
      regionCode: 'State *',
      postalCode: 'Postal Code *',
      lineOfBusiness: 'Industry *',
      companyDetails: 'Add Company Details',
      selectionAlert: 'There is no company or organization currently associated with your account.',
      selectionTips: 'Adding an organization helps us determine whether your organization has any pre-existing contracts which may affect this purchase.',
      returnBtn: 'Return to Product Page',
    },
    tooltip: {
      company: 'Please use the name of the company or organization for which you work.',
      street: 'Please provide the registered address of the company on whose behalf you are acting. This information will be used to identify the correct legal entity for contractual purposes and determine applicable taxes.',
    },
    error: {
      required: 'This field is mandatory.',
      nonLatin: 'Must include Latin characters only.',
      oneLetter: 'Must contain at least one letter.',
      maxLength: 'Must be less than {{maxLength}} characters.',
      email: 'Email address must be in a valid format (example@domain.com).',
      sameDomain: 'Unexpected e-mail domain.',
      regExpPostalCode: 'This field is invalid Postal Code.',
      forbiddenWords: 'This field contains invalid words.',
      duplicatesAddressOrCity: 'This field is the same as Address or City.',
      duplicatesAddressOrAddressLine2: 'This field is the same as Address or Address Line 2.',
      duplicatesAddressLine2: 'This field is the same as Address Line 2.',
      duplicatesCompany: 'This field is the same as Company/Organization Name',
      duplicatesAddress: 'This field is the same as Address',
      duplicatesNames: 'Must not be the same as first name',
      duplicatesNames2: 'Must not be the same as last name',
      duplicatesCity: 'This field is the same as City',
      somethingWrong: 'Something went wrong',
      validation: 'Please check the information you provided and try again. If the problem persists, don’t hesitate to contact us.',
      generic: 'It seems there’s been an issue with our system. Please try again later. If the problem persists, don’t hesitate to contact us.',
      previouslyRegisteredNonLatinName: 'You previously registered as <strong>{{firstName}} {{lastName}}</strong> with SAP. To register an account on SAP Store, please provide the English spelling of your name.',
      previouslyRegisteredTooLongName: 'You previously registered as <strong>{{firstName}} {{lastName}}</strong> with SAP. To register an account on SAP Store, please shorten your name to less than 40 characters.',
      previouslyRegisteredForbiddenWords: 'You previously registered as <strong>{{firstName}} {{lastName}}</strong> with SAP. To register an account on SAP Store, please provide a name without forbidden Words.',
      noError: ''
    },
    info: 'We use this information for billing purposes. Accurate information will\n help us to process your order efficiently.',
    creditCardRestriction: {
      individualPurchaseNotAvailableHtml: 'Thank you for your interest! This solution isn’t available for individual purchase in your country/region, but your company or organization can still purchase it.',
    },
  },
};
